import { WebCADGlobal } from "../..";
import { Mark } from "../../item";
import { ApplyBeam } from "./ApplyBeam";
import { ApplyFitting } from "./ApplyFitting";
import { ApplyItem } from "./ApplyItem";
import { DataInterface, ItemDataInterface } from './json/DataInterface';
import recognizeItemJSON = require('./json/ItemData.json');
import recognizeFittingJSON = require('./json/FittingData.json');
import recognizeBeamJSON = require('./json/BeamData.json');

export class ApplyRecognize {

    constructor() {}

    public apply(markList: Mark[]): void {
        // 画像検知マーク非表示
        WebCADGlobal.webcad2Dmanager.displayMark = false;

        markList.forEach((mark: Mark) => {
            const id = mark.itemInfo.recognizeData.id;
            const itemDatalist = this.hasItemData(id);
            if (itemDatalist && itemDatalist.length > 0) {
                new ApplyItem().apply(mark.itemInfo, itemDatalist);
            }
            const fittingData = this.hasFittingData(id);
            if (fittingData) {
                new ApplyFitting().apply(mark.itemInfo, fittingData);
            }
            const beamData = this.hasBeamData(id);
            if (beamData) {
                new ApplyBeam().apply(mark.itemInfo, beamData);
            }
        });
        WebCADGlobal.webcad2Dmanager.saveToHistory();
        WebCADGlobal.dimensionMenu.changeMode2D();
        WebCADGlobal.quotationItemList.createData();
    }

    private hasItemData(id: string): ItemDataInterface[] {
        return recognizeItemJSON.filter((data) => data.id === id);
    }
    private hasFittingData(id: string): DataInterface {
        return this.hasData(id, recognizeFittingJSON);
    }
    private hasBeamData(id: string): DataInterface {
        return this.hasData(id, recognizeBeamJSON);
    }

    private hasData<T extends DataInterface>(id: string, jsonData: ReadonlyArray<T>): T {
        return jsonData.find((data) => data.id === id);
    }

}